import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export default function RequireAdmin() {
    const { status, user } = useAuth()

    if (status === 'loading') {
        return <div className="p-4">Loading...</div>
    }

    if (!user || user.role !== 'admin') {
        return <Navigate to="/chat" replace />
    }

    return <Outlet />
}
